export default __webpack_public_path__ + "media/images/casatb/Hero-f36d3bef9311885f5d67c2b0037d51e8.jpg";